import { useEffect } from "react";
import AlexandriaLAHeroSection from "./components/HeroSection";
import AlexandriaLAStickyNav from "./components/StickyNav";
import AlexandriaLAProcessingTimeSection from "./components/ProcessingTimeSection";
import AlexandriaLAServicesSection from "./components/ServicesSection";
import AlexandriaLALocalAreaSection from "./components/LocalAreaSection";
import AlexandriaLATestimonialsSection from "./components/TestimonialsSection";
import AlexandriaLAAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlexandriaLAComparisonSection from "./components/ComparisonSection";
import AlexandriaLAMistakesSection from "./components/MistakesSection";
import AlexandriaLAHowItWorksSection from "./components/HowItWorksSection";
import AlexandriaLAFAQSection, { faqs } from "./components/FAQSection";
import AlexandriaLAHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlexandriaLAFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import AlexandriaLATravelTimingSection from "./components/TravelTimingSection";
import AlexandriaLADestinationsSection from "./components/DestinationsSection";

export default function AlexandriaLAPage() {
  useEffect(() => {
    document.title = "Emergency Passport Alexandria, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/alexandria-la/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Alexandria, LA — as fast as 24 hours. Serving medical professionals, Fort Johnson military families, and LSUA students in Rapides Parish. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Alexandria, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "31.3113;-92.4452");
    setMeta("ICBM", "31.3113, -92.4452");

    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
        { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
        { "@type": "ListItem", position: 3, name: "Alexandria Passport Services", item: pageUrl },
      ]},
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Alexandria and Central Louisiana.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Alexandria", containedInPlace: { "@type": "State", name: "Louisiana" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-alexandria-la";
    document.getElementById("structured-data-alexandria-la")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-alexandria-la")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <AlexandriaLAHeroSection />
      <AlexandriaLAStickyNav />
      <AlexandriaLAProcessingTimeSection />
      <AlexandriaLAServicesSection />
      <AlexandriaLALocalAreaSection />
      <AlexandriaLATravelTimingSection />
      <AlexandriaLADestinationsSection />
      <AlexandriaLATestimonialsSection />
      <AlexandriaLAAcceptanceFacilitiesSection />
      <AlexandriaLAComparisonSection />
      <AlexandriaLAMistakesSection />
      <AlexandriaLAHowItWorksSection />
      <AlexandriaLAFAQSection />
      <AlexandriaLAHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/alexandria-la" state="LA" />
      <AlexandriaLAFinalCTA />
    </div>
  );
}